import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

const CSS_Unordered_List = () => {
  return (
    <div className="tutorial-container">
      <h1 className="tutorial-title">📌 CSS Unordered Lists</h1>

      <p className="tutorial-intro">
        Unordered lists are defined with the <code>&lt;ul&gt;</code> tag. Each
        item in the list is wrapped in <code>&lt;li&gt;</code>. By default,
        unordered lists display items with solid round bullets, but CSS lets you
        customize them with different marker styles, icons, or even remove them
        completely.
      </p>

      {/* Section 1 */}
      <div className="tutorial-section">
        <h2 className="section-title">🔹 Default Bullets</h2>
        <p>
          By default, browsers show unordered lists with solid round bullets:
        </p>

        <CodeCopyBlock
          code={`<ul>
  <li>HTML</li>
  <li>CSS</li>
  <li>JavaScript</li>
</ul>`}
        />

        <div style={{ marginTop: "1rem" }}>
          <ul
            style={{
              background: "#f0fdf4",
              padding: "15px 30px",
              borderRadius: "8px",
              border: "1px solid #bbf7d0",
            }}
          >
            <li>HTML</li>
            <li>CSS</li>
            <li>JavaScript</li>
          </ul>
        </div>
      </div>

      {/* Section 2 */}
      <div className="tutorial-section">
        <h2 className="section-title">🔹 Different Marker Styles</h2>
        <p>
          The <code>list-style-type</code> property allows you to change the
          marker type for unordered lists:
        </p>

        <CodeCopyBlock
          code={`ul.circle {
  list-style-type: circle;
}

ul.square {
  list-style-type: square;
}

ul.none {
  list-style-type: none;
}`}
        />

        <div style={{ marginTop: "1rem" }}>
          <ul
            style={{
              listStyleType: "circle",
              background: "#eff6ff",
              padding: "15px 30px",
              borderRadius: "8px",
              border: "1px solid #bfdbfe",
              color: "#1e3a8a",
            }}
          >
            <li>Circle Marker</li>
            <li>Example Item</li>
          </ul>

          <ul
            style={{
              listStyleType: "square",
              background: "#fff7ed",
              padding: "15px 30px",
              borderRadius: "8px",
              border: "1px solid #fed7aa",
              color: "#9a3412",
              marginTop: "1rem",
            }}
          >
            <li>Square Marker</li>
            <li>Example Item</li>
          </ul>

          <ul
            style={{
              listStyleType: "none",
              background: "#faf5ff",
              padding: "15px 30px",
              borderRadius: "8px",
              border: "1px solid #e9d5ff",
              color: "#6b21a8",
              marginTop: "1rem",
            }}
          >
            <li>No Marker</li>
            <li>Example Item</li>
          </ul>
        </div>
      </div>

      {/* Section 3 */}
      <div className="tutorial-section">
        <h2 className="section-title">🔹 Custom Icons as Markers</h2>
        <p>
          You can use <code>list-style-image</code> to replace the default
          bullets with a custom image:
        </p>

        <CodeCopyBlock
          code={`ul.custom {
  list-style-image: url('check-icon.png');
}`}
        />

        <p style={{ marginTop: "1rem" }}>
          Example: Replace bullets with a checkmark icon for each item.
        </p>
      </div>

      {/* Section 4 */}
      <div className="tutorial-section">
        <h2 className="section-title">🔹 Nested Unordered Lists</h2>
        <p>
          You can also nest unordered lists, each having its own marker style:
        </p>

        <CodeCopyBlock
          code={`<ul>
  <li>Frontend
    <ul style="list-style-type: square;">
      <li>HTML</li>
      <li>CSS</li>
    </ul>
  </li>
  <li>Backend</li>
</ul>`}
        />

        <div style={{ marginTop: "1rem" }}>
          <ul
            style={{
              background: "#fef2f2",
              padding: "15px 30px",
              borderRadius: "8px",
              border: "1px solid #fecaca",
              color: "#b91c1c",
            }}
          >
            <li>
              Frontend
              <ul
                style={{
                  marginTop: "8px",
                  paddingLeft: "20px",
                  listStyleType: "square",
                  color: "#dc2626",
                }}
              >
                <li>HTML</li>
                <li>CSS</li>
              </ul>
            </li>
            <li>Backend</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CSS_Unordered_List;
